import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class DatagridService {

    private uri = "";// `${environment.apiUrl}`;
    moduleId: string;

    constructor(private http: HttpClient, private appConfigService: AppConfigService) {
      this.uri = this.appConfigService.apiBaseUrl;
    }

    GetUserReports(reportModuleId: number) {
      return this.http.post<any>(this.uri + '/Reports/GetUserReports', { moduleid: reportModuleId } );
    }

    CallReport(reportID: number) {
      return this.http.post<any>(this.uri + '/Reports/CallReport', { reportid: parseInt(this.moduleId) } );
    }

    CallGrid(data: any) {
      return this.http.post<any>(this.uri + '/Reports/CallGridDataGen', data );
    }

    CallDeleteGrid(id: number, lmoduleid: number) {
      return this.http.post<any>(this.uri + '/Reports/CallDeleteGrid', { moduleid: lmoduleid, id: id } );
    }

    GetModules(modulename) {
      return this.http.post<any>(this.uri + '/Reports/GetModules', {modulename: modulename} );
    }

    GetProcedures(procedurename) {
      return this.http.post<any>(this.uri + '/Reports/GetProcedures', {procedurename: procedurename} );
    }

    GetSPFields(procedurename) {
      return this.http.post<any>(this.uri + '/Reports/GetSPFields', {procedurename: procedurename} );
    }

    UpdateConfig(moduleid: number, procedurename: string, configstring: string) {
      return this.http.post<any>(this.uri + '/Reports/UpdateConfig', { moduleid: moduleid, procedurename: procedurename, configstring: configstring } );
    }

    GetNAVConfig(moduleid: number) {
      return this.http.post<any>(this.uri + '/Reports/GetNAVConfig', { moduleid: moduleid } );
    }

    formatDate(theDate) {

        var date = theDate;
        var aaaa = date.getFullYear();
        var gg = date.getDate();
        var mm = (date.getMonth() + 1);

        if (gg < 10)
            gg = "0" + gg;

        if (mm < 10)
            mm = "0" + mm;

        var cur_day = aaaa + "-" + mm + "-" + gg;

        var hours = date.getHours()
        var minutes = date.getMinutes()
        var seconds = date.getSeconds();

        if (hours < 10)
            hours = "0" + hours;

        if (minutes < 10)
            minutes = "0" + minutes;

        if (seconds < 10)
            seconds = "0" + seconds;

        return cur_day + " " + hours + ":" + minutes + ":" + seconds;

    }


}
